import { render, staticRenderFns } from "./GroupManager.vue?vue&type=template&id=19577053&scoped=true"
import script from "./GroupManager.vue?vue&type=script&lang=js"
export * from "./GroupManager.vue?vue&type=script&lang=js"
import style0 from "./GroupManager.vue?vue&type=style&index=0&id=19577053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19577053",
  null
  
)

export default component.exports